import PropTypes from 'prop-types'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import InfoCallout from '../tailwind/InfoCallout'

import trackEvents from '../../constants/track-events'
import { useUserContext } from '../../context'
import { trackEvent } from '../../helpers/analytics'

const SpaceSetStateHint = ({ space, spaceActions }) => {
  const { t } = useTranslation()
  const { activeSpace } = useUserContext()

  const [hideStateHintImmediately, setHideStateHintImmediately] =
    useState(false)

  const {
    id: space_id,
    smart_predict_status: {
      key: smart_predict_key,
      status: { id: smart_predict_status_id }
    }
  } = space

  const lastStateIsAlreadySmartPredict =
    smart_predict_key === 'SMART_PREDICT' &&
    smart_predict_status_id !== 'ASSESSMENT_COMPLETED' &&
    smart_predict_status_id !== 'INTEGRATION_SUCCESS' &&
    smart_predict_status_id !== 'INTEGRATION_ERROR'

  const state_already_seen_or_set =
    activeSpace.ui_space_state_hint[space_id] === 'seen' ||
    lastStateIsAlreadySmartPredict

  if (hideStateHintImmediately) return null
  if (state_already_seen_or_set) return null

  const hideSetSpaceStateHint = () => {
    setHideStateHintImmediately(true)
    trackEvent(trackEvents.HIDE_SPACE_SET_STATE_HINT)
    activeSpace.updateUiSettingsSpaceStateHint({
      key: space_id,
      value: 'seen'
    })
  }

  return (
    <InfoCallout
      onDismiss={hideSetSpaceStateHint}
      dismissLabel={t('global.close_action')}
      action={
        <button
          type='button'
          onClick={() => spaceActions.setDisplaySetSpaceState(true)}
          className='whitespace-nowrap rounded font-medium text-primaryBlue hover:text-primaryBlue/80 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primaryBlue'
        >
          {t('space.space_set_state_hint.action')}
        </button>
      }
    >
      {t('space.space_set_state_hint.title')}
    </InfoCallout>
  )
}

SpaceSetStateHint.propTypes = {
  space: PropTypes.object.isRequired,
  spaceActions: PropTypes.object.isRequired
}

export default SpaceSetStateHint
